import angular from 'angular';

module.exports = angular.module('market.routes.humans.login', [
  require('angular-ui-router')
])
.config(function($stateProvider) {
  $stateProvider.state('humans.login', {
    url: '/login',
    template: require('./login.jade')(),
  });
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/routes/humans/login.js
 **/